export const MY_MEETINGS_ROUTE_NAMES = {
  /** Parent record: redirects to the open tab. */
  MY_MEETINGS: "myMeetings",
  MY_MEETINGS_OPEN: "myMeetingsOpen",
  MY_MEETINGS_COMPLETED: "myMeetingsCompleted",
  MY_MEETINGS_MEETING_ID: "MyMeetingsMeetingId",
  MY_MEETINGS_TEACHER_SHORTAGE: "MyMeetingsTeacherShortage",
} as const;

export type MyMeetingsRouteName =
  (typeof MY_MEETINGS_ROUTE_NAMES)[keyof typeof MY_MEETINGS_ROUTE_NAMES];
